/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * enumeration of crown capability names
 */
export var CrownCapNames;
(function (CrownCapNames) {
    CrownCapNames["CROWNSOLID"] = "_crownSolid";
    CrownCapNames["CROWNSCAN"] = "_crownScan";
    CrownCapNames["CROWNSHAPE"] = "_crownShape";
    CrownCapNames["CROWNIMAGE"] = "_crownImage";
    CrownCapNames["CROWNPOINTCLOUD"] = "_crownPointCloud";
    CrownCapNames["CROWNHEIGHTMAP"] = "_crownHeightmap";
    CrownCapNames["CROWNTEXT"] = "_crownText";
    CrownCapNames["CROWNMESH"] = "_crownMesh";
})(CrownCapNames || (CrownCapNames = {}));
//# sourceMappingURL=CrownCapNames.js.map